import { render } from "./AddGlobalPriceForm.vue?vue&type=template&id=d8d46d72&ts=true"
import script from "./AddGlobalPriceForm.vue?vue&type=script&lang=ts"
export * from "./AddGlobalPriceForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__